import { Text, VStack, Box, Image, Flex } from '@chakra-ui/react'
import { useTranslation, Trans } from 'next-i18next'
import { useInView } from 'react-intersection-observer'

import CarouselComponent, {
  CarouselContextProvider,
} from '@/features/services/components/Carousel'

function Carousel(): React.ReactElement {
  const { t } = useTranslation('services')

  const { inView, ref } = useInView({
    threshold: 0.1,
  })

  return (
    <CarouselContextProvider autoRotate={inView}>
      <Box
        ref={ref}
        sx={{
          overflowX: 'hidden',
        }}
      >
        <VStack
          spacing="4"
          layerStyle="container"
          sx={{
            alignItems: 'center',
            color: 'gray.900',
            pb: 0,
          }}
        >
          <Flex
            flexDir={{
              base: 'column',
              md: 'row',
            }}
            sx={{
              gap: {
                base: '18px',
                md: '16px',
              },
            }}
          >
            <Image
              src="/images/services/training/video-chat.png"
              width={{
                base: '40px',
                sm: '76px',
              }}
              h="auto"
              mx="auto"
            />
            <Text
              as="h1"
              sx={{
                fontSize: {
                  base: 'lg',
                  sm: '2xl',
                },
                fontWeight: 'medium',
                textAlign: 'center',
                my: 'auto',
              }}
            >
              <Trans t={t} i18nKey="training.expreriance.title">
                บรรยากาศการเรียนการสอนจากทีมกฎหมาย
                <Text
                  as="strong"
                  sx={{ fontWeight: 'medium', color: 'primary.400' }}
                >
                  PDPA Core
                </Text>
              </Trans>
            </Text>
          </Flex>
          <CarouselComponent />
        </VStack>
      </Box>
    </CarouselContextProvider>
  )
}

export default Carousel
